var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWakeUp = function SvgWakeUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.727 14.214a4.601 4.601 0 0 0-1.384-3.283A4.77 4.77 0 0 0 12 9.571a4.77 4.77 0 0 0-3.342 1.36 4.601 4.601 0 0 0-1.385 3.283M6.902 9.207l-.72-.707m10.916.707.72-.707M12 7.129V6m-7.215 8.214H4m16 0h-.785",
    stroke: "#FBFF2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.182 16h11.636",
    stroke: "#FBFF2F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgWakeUp;